export default __webpack_public_path__ + "static/media/1823.aac14a56.png";